import $ from 'jquery';
import initSelect2 from 'widgets/Select2';
import replaceFormPrefix from '../utils/ReplaceFormPrefix';
import resetForm from '../utils/ResetForm';
import triggerConfirmationForm from '../utils/confirmation';
import {gettext} from "../utils/text";
import {unsavedChangesMessage} from "./site_edit";


export default function () {
    const deleteButtonText = gettext('Delete');
    const totalForms = $('#id_certificates-TOTAL_FORMS');
    const initTotalForms = parseInt(totalForms.val(), 10) - 1;

    // Adding styled delete button
    if ($('.form-certificates').length) {
        $('.obsolete-checkbox .form-group').append(
            `<a class="btn btn-link btn-list-remove"><i class="icon icon-remove"></i>${deleteButtonText}</a>`
        );
    }

    const newFormRows = $('.select-new');
    // Cloning the form to a constant
    const newCertificates = newFormRows.clone(true, true);
    const certificateTemplate = newCertificates.first();
    newFormRows.remove();

    // Adding initial form
    const initialRows = newCertificates.clone(true, true);
    initialRows.removeClass("select-new");
    $('#certificates').prepend(initialRows);
    initSelect2({placeholder: ''});

    // Add new row when we click on Add button
    $('.btn-add-certificate').click((e) => {
        e.preventDefault();
        const row = resetForm(certificateTemplate.clone(true, true));

        const newTotalForms = parseInt(totalForms.val(), 10);
        const newRow = replaceFormPrefix(row, "certificates", `-${initTotalForms}-`, `-${newTotalForms}-`);
        newRow.removeClass("select-new");
        $('#certificates').prepend(newRow);
        totalForms.val(newTotalForms + 1);
        initSelect2({placeholder: ''});
        triggerConfirmationForm();
    });

    // Hide row & add prop checked when you have clicked on delete button
    $(document).on('click', '.btn-list-remove', function onClick(e) {
        e.preventDefault();
        window.onbeforeunload = () => unsavedChangesMessage;

        const parent = $(this).parents().eq(2);

        if (!parent.hasClass("js-existing-row")) {
            parent.remove();
            return;
        }

        // Detecting the select list and the reg number
        const selectList = parent
            .children('div.select-list')
            .children('div.form-group')
            .children('div.controls')
            .children('select');

        // If we don't have the values, but we need to delete it. We add some generic data because the form needs it
        if (!selectList.val()) {
            selectList
                .children('option')
                .removeAttr('selected')
                .filter('[value=1]')
                .attr('selected', true);
        }

        // Checked the obsolete input checkbox and hide the row
        $(this).parent()
            .children('div.checkbox')
            .children('label')
            .children('input')
            .prop('checked', true);

        parent.addClass('hidden');
    });
}
